module.exports = __webpack_public_path__ + "img/img-introduce-005.41060541.png";